/* @flow */
import * as React from 'react';
import { inject } from 'mobx-react';
import { NavLink } from 'react-router-dom';

import styles from './DevMenu.module.scss';

type TypeState = {|
  devmenuOpen: boolean,
|};

@inject('authenticationStore')
export default class DevMenu extends React.Component<*, TypeState> {
  state = {
    devmenuOpen: false,
  };

  devmenuToggle() {
    this.setState({
      devmenuOpen: !this.state.devmenuOpen,
    });
  }

  render(): React.Element<*> {
    const state: TypeState = this.state;

    // @see scripts/build-env-vars.js
    // eslint-disable-next-line no-process-env, no-undef
    const appVersion: ?string = process.env.REACT_APP_VERSION_NUMBER;

    return (
      <div className={state.devmenuOpen ? styles['dev-menu'] : styles['dev-menu--closed']}>
        <span className={styles['toggle-menu']} onClick={this.devmenuToggle.bind(this)}>
          {state.devmenuOpen ? 'Close Menu' : 'Open Menu'}
        </span>
        <ul>
          <h1>Dev Menu</h1>
          <h4>Customer Portal version {appVersion}</h4>
          <li>
            <NavLink to="/login">Login</NavLink>
          </li>
          <li>
            <NavLink to="/signup"> Sign Up</NavLink>
          </li>
          <li>
            <NavLink to="/magic-link"> Magic Link</NavLink>
          </li>
          <li>
            <NavLink to="/email-verified"> Email verified </NavLink>
          </li>
          <li>
            <NavLink to="/signup-complete"> Sign Up Complete</NavLink>
          </li>
          <li>
            <NavLink to="/forgotten-password"> Forgotten Password</NavLink>
          </li>
          <li>
            <NavLink to="/password-reset"> Password Reset</NavLink>
          </li>
          <li>
            <NavLink to="/password-updated"> Password Updated</NavLink>
          </li>
          <li>
            <NavLink to="/location-chooser"> Location Chooser</NavLink>
          </li>
          <li>
            <NavLink to={{ pathname: '/notifications', state: { tab: 1 } }}> Notifications</NavLink>
          </li>
          <li>
            <NavLink to="/profile">Profile</NavLink>
          </li>
        </ul>
      </div>
    );
  }
}
